import React from "react";
import {useDispatch, useSelector} from "react-redux";
import TableComponent from "../../../Components/TableComponentFiles/TableComponent";
import {useEffect} from "react";
import {fetchCategoryList} from "../../../redux/actions/CategoryActions";
import {useLocation} from "react-router-dom";
import Loading from "../../../Components/loading";

const CategoriesPage = ({type}) => {
    const {categories, success, loading} = useSelector((state) => state.categoryList);
    let categoriesData = []
    const dispatch = useDispatch()
    const location = useLocation()
    useEffect(() => {
        categoriesData = []
        dispatch(fetchCategoryList())
    }, [location])
    success && categories.map((x, i) => {
            const obj = {
                id: x.id,
                image: x.image,
                name: x.name,
                description: x.description,
                ...x,
                updated_at: getDate(x.updated_at),
                created_at: getDate(x.created_at)
            }
            if (type === "deleted") {
                if (obj.visibility === 0) {
                    categoriesData.push(obj)
                }
            } else if (type === "drafted") {
                if (obj.visibility === 2) {
                    categoriesData.push(obj)
                }
            } else if (type === "all") {
                if (obj.visibility === 1) {
                    categoriesData.push(obj)
                }
            }

        }
    )

    return (
        <React.Fragment>
            {success &&
                <TableComponent TableData={categoriesData} tableName={capitalizeFirstLetter(type) + " Categories"}/>}
            {loading && <Loading/>}
        </React.Fragment>
    )
}
const getDate = (givenDate) => {
    const date = new Date(givenDate);
    const options = {day: 'numeric', month: 'long', year: 'numeric'};
    const formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate
}
const capitalizeFirstLetter = (str) => {
    return str.replace(/^\w/, (firstLetter) => firstLetter.toUpperCase());
};
export default CategoriesPage